<div class="container-fluid">
  <div class="row">
    <ng-template #sidebarOffcanvas let-offcanvas>
      <div class="offcanvas-header">
        <h6 class="offcanvas-title text-muted" id="offcanvas-basic-title" ngbAutofocus>
          ระบบลงทะเบียนสิทธิหลักประกันสุขภาพแห่งชาติ</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
      </div>
      <div class="offcanvas-body">
        <div id="sidebar-offcanvas">
          <div tabindex="-1" aria-labelledby="sidebar-menu-label">
            <div class="flex-column">
              <ng-container [ngTemplateOutlet]="sidebar"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isSidebarCollapsed" [horizontal]="true" class="col-auto p-0">
      <div id="sidebar">
        <div id="sidebar-menu" tabindex="-1" aria-labelledby="sidebar-menu-label">
          <div class="flex-column">
            <ng-container [ngTemplateOutlet]="sidebar"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col overflow-y-auto p-0">
      <header id="header" class="sticky-top w-100 position-relative">
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid">
            @if (toggleOffCanvas) {
              <button class="navbar-toggler d-block border-0 rounded px-1" type="button"
                      (click)="openSidebarOffcanvas(sidebarOffcanvas)">
                <i class="bi bi-layout-sidebar text-white fs-3"></i>
              </button>
            } @else {
              <button class="navbar-toggler d-block border-0 rounded px-1" type="button"
                      [attr.aria-expanded]="!isSidebarCollapsed"
                      (click)="collapse.toggle()">
                <i class="bi bi-layout-sidebar text-white fs-3"></i>
              </button>
            }
            <div class="collapse navbar-collapse ms-3" id="navbarSupportedContent">
              <ul id="select-font-size" class="navbar-nav me-auto mb-lg-0">
                <li class="nav-item me-1" (click)="setFontSizeTo('14px')">
                  <input type="radio" class="btn-check" name="options" id="fs14px" [value]="'14px'"
                         [(ngModel)]="selectedFontSize" autocomplete="off">
                  <label class="btn btn-outline-light py-0" for="fs14px">ก</label>
                </li>
                <li class="nav-item me-1" (click)="setFontSizeTo('16px')">
                  <input type="radio" class="btn-check" name="options" id="fs16px" [value]="'16px'"
                         [(ngModel)]="selectedFontSize" autocomplete="off">
                  <label class="btn btn-outline-light py-0" for="fs16px">ก+</label>
                </li>
                <li class="nav-item me-1" (click)="setFontSizeTo('18px')">
                  <input type="radio" class="btn-check" name="options" id="fs18px" [value]="'18px'"
                         [(ngModel)]="selectedFontSize" autocomplete="off">
                  <label class="btn btn-outline-light py-0" for="fs18px">ก++</label>
                </li>
              </ul>
            </div>
            <div class="dropdown flex-row text-end me-1">
              <a role="button" class="d-block text-decoration-none dropdown-toggle"
                 style="font-size: 12.5px" data-bs-toggle="dropdown" aria-expanded="false">
                {{ principal?.name }} <br>
                <small style="font-size: 0.8rem">{{ principal?.organization?.id }}
                  - {{ principal?.organization?.name }}</small>
              </a>
              <ul class="dropdown-menu dropdown-menu-start text-small" style="right: 0;">
                <li class="cursor-pointer"><a (click)="profile()" class="dropdown-item"><i
                  class="bi bi-person me-2"></i>โปรไฟล์</a></li>
                <li class="cursor-pointer"><a (click)="switchUser()"
                                                                          class="dropdown-item"><i
                  class="bi bi-arrow-repeat me-2"></i>สลับ User</a></li>
                <li class="cursor-pointer"><a (click)="logout()" class="dropdown-item"><i
                  class="bi bi-box-arrow-in-right me-2"></i>ออกจากระบบ</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <div id="content">
        <div class="ps-3 pt-3 pe-3 pb-5 mb-5">
          @if (isTestEnv()) {
            <ngb-alert type="custom" class="text-center fw-semibold fixed-bottom">
              ขณะนี้คุณกำลังใช้งานบน TEST ZONE สปสช.
              <div class="marquee">
                <div class="overlay">
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                  TEST ZONE
                </div>
              </div>
            </ngb-alert>
          }
          <app-loading></app-loading>
          <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
          <app-header></app-header>
          <router-outlet/>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #sidebar>
  @if (!toggleOffCanvas) {
    <ul class="nav flex-column sticky-top" style="background: #0a4bac; height: 52px;">
      <li class="nav-item d-flex justify-content-center p-2">
        <a class="navbar-brand d-none d-md-flex">
          <img src="/assets/images/nhso-minimize.webp" alt="Logo" class="">
          <div class="text-white">ระบบลงทะเบียนสิทธิหลักประกันสุขภาพแห่งชาติ</div>
        </a>
      </li>
    </ul>
  }
  <div id="sidebar-content">
    <ul class="nav flex-column mt-4">
      <li class="nav-item">
        <a class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2"
           href="{{environment.srmPortalUrl}}/secure">
          <i class="bi bi-grid-fill"></i>
          ไปที่ Portal
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/secure/landing"
           routerLinkActive="active"
           class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
          <i class="bi bi-house-fill"></i>
          ข่าวประชาสัมพันธ์
        </a>
      </li>
    </ul>
    <ul
      *hasAnyAuthority="['admin', 'chk_right', 'reg_chk_right', 'senior_regis', 'chk_right_other', 'regis_zone', 'staff_call_center', 'regis_call_center', 'reg_exch_other']"
      customNavCollapse class="nav flex-column">
      <li class="nav-item" (click)="rightSearchCollapsed =!rightSearchCollapsed"
          [attr.aria-expanded]="!rightSearchCollapsed">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-shield-fill-check"></i>
          <span>ตรวจสอบข้อมูล</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div [(ngbCollapse)]="rightSearchCollapsed" class="collapse" id="right-search-collapse" style="">
        <li
          *hasAnyAuthority="['admin', 'chk_right', 'reg_chk_right', 'senior_regis', 'regis_zone', 'staff_call_center', 'regis_call_center']"
          class="nav-item">
          <a
            class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2"
            routerLink="/secure/right-search"
            routerLinkActive="active">
            ตรวจสอบสิทธิรายบุคคล/ลงทะเบียน
          </a>
        </li>
        <li
          *hasAnyAuthority="['admin', 'chk_right', 'reg_chk_right', 'senior_regis', 'chk_right_other', 'regis_zone', 'staff_call_center', 'regis_call_center', 'reg_exch_other']"
          class="nav-item">
          <a routerLink="/secure/check-group" routerLinkActive="active"
             class="nav-link btn  d-flex text-start align-middle  border-0 gap-2">
            ตรวจสอบสิทธิแบบกลุ่ม
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'regis_zone']" class="nav-item">
          <a class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2"
             routerLink="/secure/history/uc"
             routerLinkActive="active">
            ประวัติการลงทะเบียน UC
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'regis_zone']" class="nav-item">
          <a class="nav-link btn  d-flex text-start align-middle  border-0 gap-2"
             routerLink="/secure/digital-address"
             routerLinkActive="active">
            ตรวจสอบที่อยู่ (Digital Address)
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'chk_right_sss']" class="nav-item">
          <a class="nav-link btn  d-flex text-start align-middle  border-0 gap-2"
             routerLink="/secure/search-sss"
             routerLinkActive="active">
            ข้อมูลหมดสิทธิประกันสังคมรายวัน
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'regis_zone']" class="nav-item">
          <a routerLink="right-history" routerLinkActive="active"
             class="nav-link btn  d-flex text-start align-middle  border-0 gap-2">
            ตรวจสอบหลักฐานหลังการเกิดสิทธิ
          </a>
        </li>
      </div>
    </ul>
    <ul class="nav flex-column" customNavCollapse
        *hasAnyAuthority="['admin', 'senior_regis', 'regis_zone', 'staff_call_center', 'regis_call_center']">
      <li class="nav-item" data-bs-toggle="collapse" data-bs-target="#registration-collapse">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-person-fill"></i>
          <span>ลงทะเบียนรายบุคคล</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div class="collapse" id="registration-collapse" style="">
        <li class="nav-item">
          <a routerLink="registration/thaid" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            ด้วย ThaID
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="registration/idcard" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            ด้วยบัตร Smart Card
          </a>
        </li>
      </div>
    </ul>
    <ul class="nav flex-column" customNavCollapse
        *hasAnyAuthority="['admin', 'general', 'army', 'airforce', 'navy', 'moe_student', 'other_student', 'mercy_house', 'hosp_prison', 'prison', 'nhso_zone_prison']">
      <li class="nav-item" data-bs-toggle="collapse" data-bs-target="#group-collapse">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-people-fill"></i>
          <span>ลงทะเบียนแบบกลุ่ม</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div class="collapse" id="group-collapse" style="">
        <li class="nav-item">
          <a routerLink="/secure/group-register/history" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            ประวัติการลงทะเบียนแบบกลุ่ม
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'general']" class="nav-item">
          <a routerLink="/secure/group-register/general/new" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มทั่วไป
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'army']" class="nav-item">
          <a routerLink="/secure/group-register/army" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มทหารบก
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'navy']" class="nav-item">
          <a routerLink="/secure/group-register/navy" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มทหารเรือ
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'airforce']" class="nav-item">
          <a routerLink="/secure/group-register/airforce" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มทหารอากาศ
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'moe_student']" class="nav-item">
          <a routerLink="/secure/group-register/moe-student" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มนักศึกษาสังกัดกระทรวงศึกษาธิการ
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'other_student']" class="nav-item">
          <a routerLink="/secure/group-register/other-student" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มนักศึกษา อื่นๆ
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'hosp_prison', 'prison', 'nhso_zone_prison']" class="nav-item">
          <a routerLink="/secure/group-register/prisoner" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มผู้ต้องขัง
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'mercy_house']" class="nav-item">
          <a routerLink="/secure/group-register/mercy/new" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มบ้านเมตตา
          </a>
        </li>
        <li *hasAnyAuthority="['admin']" class="nav-item">
          <a routerLink="/secure/ucep"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่ม UCEP
          </a>
        </li>
        <li *hasAnyAuthority="['admin']" class="nav-item">
          <a routerLink="/secure/group-register/reinstate" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            กลุ่มคืนสิทธิ
          </a>
        </li>
        <!--        <li *hasAnyAuthority="['admin']" class="nav-item">-->
        <!--          <a routerLink="/secure/uc-advance" routerLinkActive="active"-->
        <!--             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">-->
        <!--            กลุ่มสิทธิ UC ล่วงหน้า-->
        <!--          </a>-->
        <!--        </li>-->
      </div>
    </ul>
    <ul class="nav flex-column" customNavCollapse *hasAnyAuthority="['admin', 'regis_zone']">
      <li class="nav-item" data-bs-toggle="collapse" data-bs-target="#arbitrary-collapse">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>ข้อมูลการลงทะเบียนที่ผิดปกติ</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div class="collapse" id="arbitrary-collapse" style="">
        <li class="nav-item">
          <a routerLink="arbitrary/summary" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            สรุปผลดำเนินงาน
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="arbitrary/new" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            งานใหม่
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="arbitrary/tasks" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            ติดตามสถานะการตรวจสอบ
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="arbitrary/report" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            ส่งรายงานผลการตรวจสอบ
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="arbitrary/email" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            จัดการอีเมล
          </a>
        </li>
      </div>
    </ul>
    <ul class="nav flex-column" customNavCollapse
        *hasAnyAuthority="['admin', 'senior_regis', 'regis_zone', 'staff_call_center', 'regis_call_center', 'reg_exch_other']">
      <li class="nav-item">
        <a
          class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2"
          routerLink="/secure/revoked"
          routerLinkActive="active">
          <i class="bi bi-unlock-fill"></i>
          ปลดสิทธิกองทุนอื่น
        </a>
      </li>
    </ul>
    <ul class="nav flex-column" customNavCollapse *hasAnyAuthority="['admin', 'regis_zone']">
      <li class="nav-item" data-bs-toggle="collapse" data-bs-target="#transfer-collapse">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-box-fill"></i>
          <span>โอนย้ายข้อมูล</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div class="collapse" id="transfer-collapse" style="">
        <li *hasAnyAuthority="['admin','regis_zone']" class="nav-item">
          <a routerLink="/secure/transfer/history" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            ประวัติการโอนย้ายข้อมูลผู้มีสิทธิ
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'regis_zone']" class="nav-item">
          <a routerLink="/secure/transfer/transfer-person-data" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            โอนย้ายข้อมูลผุ้มีสิทธิ
          </a>
        </li>
        <li *hasAnyAuthority="['admin']" class="nav-item">
          <a routerLink="/secure/transfer/transfer-population" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            นำเข้าข้อมูลผู้มีสิทธิ (สำหรับผู้ดูแลระบบ)
          </a>
        </li>
        <li *hasAnyAuthority="['admin']" class="nav-item">
          <a routerLink="/secure/transfer/transfer-population-history" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            ประวัติการนำเข้าข้อมูลผู้มีสิทธิ (สำหรับผู้ดูแลระบบ)
          </a>
        </li>
      </div>
    </ul>
    <ul class="nav flex-column" customNavCollapse *hasAnyAuthority="['admin', 'regis_zone', 'hospital']">
      <li class="nav-item" data-bs-toggle="collapse" data-bs-target="#point-collapse">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-8-circle-fill"></i>
          <span>บริหารจัดการ POINT</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div class="collapse" id="point-collapse" style="">
        <li class="nav-item" *hasAnyAuthority="['admin']">
          <a routerLink="/secure/point/current" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            คำนวณเหมาจ่ายรายหัว
          </a>
        </li>
        <li class="nav-item" *hasAnyAuthority="['admin']">
          <a routerLink="/secure/point/history" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            ประวัติการคำนวณเหมาจ่ายรายหัว
          </a>
        </li>
        <li *hasAnyAuthority="['admin', 'regis_zone', 'hospital']" class="nav-item">
          <a routerLink="/secure/point/summary-report" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            รายงานคำนวณเหมาจ่ายรายหัว
          </a>
        </li>
        <li class="nav-item" *hasAnyAuthority="['admin']">
          <a routerLink="/secure/point/excluded-hospitals" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            ตรวจสอบหน่วยบริการที่ออกจากระบบ
          </a>
        </li>
        <li class="nav-item" *hasAnyAuthority="['admin']">
          <a routerLink="/secure/point/manage-email-point" routerLinkActive="active"
             class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">
            จัดการอีเมล Point
          </a>
        </li>
      </div>
    </ul>
<!--    <ul class="nav flex-column" customNavCollapse-->
<!--        *hasAnyAuthority="['admin']">-->
<!--      <li class="nav-item">-->
<!--        <a routerLink="/secure/modify-right" routerLinkActive="active"-->
<!--           class="nav-link  d-flex align-items-start align-middle  border-0 gap-2">-->
<!--          <i class="bi bi-passport-fill"></i> แก้ไขสิทธิรักษาพยาบาล-->
<!--        </a>-->
<!--      </li>-->
<!--    </ul>-->
    <ul class="nav flex-column" customNavCollapse
        *hasAnyAuthority="['admin', 'reg_chk_right', 'senior_regis', 'regis_zone']">
      <li class="nav-item">
        <a class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2"
           href="{{environment.authenCodeUrl}}" target="_blank">
          <i class="bi bi-pass-fill"></i>
          ตรวจสอบสิทธิและยืนยันการเข้ารับบริการ
        </a>
      </li>
    </ul>
    <ul class="nav flex-column" customNavCollapse *hasAnyAuthority="['admin']">
      <li class="nav-item" data-bs-toggle="collapse" data-bs-target="#settings-collapse">
        <a class="nav-link nav-link-collapse">
          <i class="bi bi-gear-fill"></i>
          <span>การตั้งค่า</span>
          <i class="rtl:rotate-180 right-icon"
             x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''" style="">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </li>
      <div class="collapse" id="settings-collapse" style="">
        <li class="nav-item">
          <a routerLink="/secure/settings/group-register-hospital" routerLinkActive="active"
             class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">
            หน่วยบริการที่ลงทะเบียนแบบกลุ่ม
          </a>
        </li>

        <ng-container *hasAnyAuthority="['u99']">
          <li class="nav-item">
            <a routerLink="/secure/settings/rate-limit-monitor" routerLinkActive="active"
               class="nav-link btn  d-flex align-middle text-start border-0 gap-2">
              UCWS Rate Limit
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/secure/settings/user-rate-limit-monitor" routerLinkActive="active"
               class="nav-link btn  d-flex align-middle text-start border-0 gap-2">
              User Rate Limit
            </a>
          </li>
        </ng-container>
      </div>
    </ul>

    <!--              todo-->
    <!--              <ul class="nav flex-column">-->
    <!--                <li class="nav-item">-->
    <!--                  <h6-->
    <!--                    class="sidebar-heading d-flex justify-content-between align-items-center text-body-secondary">-->
    <!--                    ทะเบียนพลการ-->
    <!--                  </h6>-->
    <!--                </li>-->
    <!--                <li class="nav-item">-->
    <!--                  <a (click)="notImplementedYet()"-->
    <!--                     class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">-->
    <!--                    <i class="bi bi-bar-chart-steps"></i>-->
    <!--                    รายงานสรุปผลการดำเนินงาน-->
    <!--                  </a>-->
    <!--                </li>-->
    <!--                <li class="nav-item">-->
    <!--                  <a routerLink="change-health-insurance" routerLinkActive="active"-->
    <!--                     class="nav-link btn  d-flex align-items-center align-middle text-start  border-0 gap-2">-->
    <!--                    <i class="bi bi-bar-chart-steps"></i>รายงานการเปลี่ยนแปลงสิทธิประกันสุขภาพ และสิทธิว่างกรณีอื่น-->
    <!--                  </a>-->
    <!--                </li>-->
    <!--                <li class="nav-item">-->
    <!--                  <a routerLink="deceased-eligible-service" routerLinkActive="active"-->
    <!--                     class="nav-link btn  d-flex align-items-center align-middle text-start  border-0 gap-2">-->
    <!--                    <i class="bi bi-bar-chart-steps"></i>รายงานผู้มีสิทธิที่เสียชีวิตที่ลงทะเบียนในเครือข่ายหน่วยบริการ-->
    <!--                  </a>-->
    <!--                </li>-->
    <!--                <li class="nav-item">-->
    <!--                  <a (click)="notImplementedYet()"-->
    <!--                     class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">-->
    <!--                    <i class="bi bi-stopwatch"></i>-->
    <!--                    ติดตามสถานะการตรวจสอบ-->
    <!--                  </a>-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--              todo-->
    <!--              <ul class="nav flex-column">-->
    <!--                <li class="nav-item">-->
    <!--                  <h6-->
    <!--                    class="sidebar-heading d-flex justify-content-between align-items-center text-body-secondary">-->
    <!--                    แก้ไขข้อมูล-->
    <!--                  </h6>-->
    <!--                </li>-->
    <!--                <li class="nav-item">-->
    <!--                  <a (click)="notImplementedYet()"-->
    <!--                     class="nav-link btn  d-flex align-items-center align-middle  border-0 gap-2">-->
    <!--                    <i class="bi bi-pencil-square"></i>-->
    <!--                    แก้ไขสิทธิการรักษาพยาบาล-->
    <!--                  </a>-->
    <!--                </li>-->
    <!--              </ul>-->
    <div class="sidebar-footer">
      <i class="bi bi-tag-fill me-1"></i>
      <span>เวอร์ชัน {{ appVersion || '-' }}</span>
    </div>
  </div>
</ng-template>
